import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
import { Tooltip } from '@mui/material';
import AvailabityDetails from './AvailabityDetails';
import SnackbarContent from '@mui/material/SnackbarContent';
import EditIcon from '@mui/icons-material/Edit';
import Badge from "react-bootstrap/Badge";
import LinearProgress from '@mui/material/LinearProgress';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { ERROR_MESSAGES, RIDER_AVAILABILITY_STATUS_OFF_DUTY, RIDER_AVAILABILITY_STATUS_ON_VACATION } from '../../../utils/pnd/PndConstants';
import UpdateRiderAvaiabilityStatusModal from './UpdateRiderAvaiabilityStatusModal';
import { showNotification } from 'src/shared/components/Notification';

const AvailabityDetailsIndex = () => {
  useEffect(() => {
    GetAllRidersDetails();
  }, [])
  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [isRiderRecords, setRiderRecords] = useState([]);

  const GetAllRidersDetails = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllRidersDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
        setRiderRecords(response?.data?.data);
      } else if (response.status === 200 && response.data.status === 204) {
        setNoRecordFound(true);

      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };


  const columns = useMemo(
    () => [

      { key: 'riderName', header: 'Rider Name' },
      {
        key: 'availabilityInfo',
        header: 'Availability',
        render: (value, row) => {
          let bg = 'success';
          if (row.riderAvailabilityId === RIDER_AVAILABILITY_STATUS_ON_VACATION) bg = 'danger';
          else if (row.riderAvailabilityId === RIDER_AVAILABILITY_STATUS_OFF_DUTY) bg = 'warning';
          return <Badge bg={bg}>{row.riderAvailabilityDesc}</Badge>;
        },
      },
    ],
    [],
  );

  const edit = async (event) => {
    if (event.riderId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Rider Availability Details");
    }
  }
  return (
    <Container>

      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) &&
        <AvailabityDetails reactTableData={reactTableData} dataInfo={isRiderRecords} onEdit={edit} />}
      {isNoRecordFound && <AvailabityDetails isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <SnackbarContent message={'No Record Found'} />}
      {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
      {viewDetailPopup &&
        <UpdateRiderAvaiabilityStatusModal
          open={viewDetailPopup}
          setOpen={setViewDetailPopup}
          dataInfo={temp}
          isTitle={isTitle}
        />}

      {/*
      {
        isDutyApproval &&
        <DutyExtensionModal
          modalShow={isDutyApproval}
          setModalShow={setDutyApproval}
          isRiderRequestedHr={isRiderRequestedHr}
          isTitle={isTitle}
          dataInfo={temp}
        />
      }

      {showConfirmation && (
        <ConfirmationDialog
          open={showConfirmation}
          onClose={closeDialog}
          onConfirm={() => processOrder(temp)} // Pass the temp data to assignOrder
          title="Confirmation"
          message="Do you allow him to extend his duty?"
        />
      )
      } */}
    </Container>
  );
};

export default AvailabityDetailsIndex;